import { render, staticRenderFns } from "./UserSelect.vue?vue&type=template&id=5c09dd88&scoped=true"
import script from "./UserSelect.vue?vue&type=script&lang=js"
export * from "./UserSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c09dd88",
  null
  
)

export default component.exports